import {defaultState} from './state';
import * as UTMActions from '../actions/UTMActions';
import {Cookie} from '../types/mx/creditoReal/epics';
import {NAME_COOKIE} from '../constants/MotorcreditConstants';
import * as CookieUtils from '../../common/utils/CookieUtils';
import * as StateConstants from '../constants/StateConstants';

const utmData = (state = defaultState.utmData, action) => {

    switch (action.type) {
        case UTMActions.SET_UTM_VALUES_ACTION.name:
            const cookieValue: Cookie = !!CookieUtils.getCookie(NAME_COOKIE) && JSON.parse(CookieUtils.getCookie(NAME_COOKIE)) || '';
            const utmSourceCookie = CookieUtils.getCookie(StateConstants.UTM_SOURCE) || '';
            const utmMediumCookie = CookieUtils.getCookie(StateConstants.UTM_MEDIUM) || '';
            const utmCampaignCookie = CookieUtils.getCookie(StateConstants.UTM_CAMPAIGN) || '';
            const utmTermCookie = CookieUtils.getCookie(StateConstants.UTM_TERM) || '';
            const utmContentCookie = CookieUtils.getCookie(StateConstants.UTM_CONTENT) || '';
            const gclidCookie = CookieUtils.getCookie(StateConstants.GCLID) || '';
            return {
                ...state,
                utmSource: utmSourceCookie,
                utmMedium: utmMediumCookie,
                utmCampaign: utmCampaignCookie,
                utmTerm: utmTermCookie,
                utmContent: utmContentCookie,
                gclid: gclidCookie,
                aUtmUrl: cookieValue.aUtmUrl ? cookieValue.aUtmUrl : '',
                firstReferer: cookieValue.firstReferer,
                aHttpRefer: action.aHttpRefer,
                userAgent: action.userAgent,
                typeDevice: action.typeDevice,
                operatingSystem: action.operatingSystem,
                resolutionWidth: action.resolutionWidth,
                resolutionHeight: action.resolutionHeight
            };
        default:
            return state;
    }
};

export default utmData;
